
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/UserDocs/Benefits",
      function () {
        return require("private-next-pages/docs/UserDocs/Benefits.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/UserDocs/Benefits"])
      });
    }
  